module.exports = __webpack_public_path__ + "static/assets/hdfc-life.png";